// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KkZs","placeholdersHeader":"styles_placeholdersHeader__2xd49","editorStyle":"styles_editorStyle__yS_wj","placeholdersBox":"styles_placeholdersBox__25So1"};